import React from 'react'
import { motion } from 'framer-motion'
import APP1SCREEN from '../../../../app/assets/images/projectImage/quivverImages/dreamMockup.webp'

const QuivverDream = () => {
    return (
        <div className='px-4 sm:px-6 md:px-12 lg:px-20 xl:px-40'>
            <div className='flex flex-col md:flex-row items-center justify-center pt-12 sm:pt-16 md:pt-20 lg:pt-24 gap-6 md:gap-8 lg:gap-12'>
                <motion.img
                    src={APP1SCREEN}
                    alt='QuivverDream'
                    className='w-full md:w-[50%] h-full object-cover order-1 md:order-1'
                    initial={{ opacity: 0, x: -80, y: 30 }}
                    whileInView={{ opacity: 1, x: 0, y: 0 }}
                    transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1.0] }}
                    viewport={{ once: false, amount: 0.3 }}
                />
                <motion.div
                    className='flex flex-col gap-4 w-full md:w-auto order-2'
                    initial={{ opacity: 0, x: 80, y: 30 }}
                    whileInView={{ opacity: 1, x: 0, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1.0] }}
                    viewport={{ once: false, amount: 0.3 }}
                >
                    <motion.div
                        className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-snug pl-0 sm:pl-4 md:pl-10 lg:pl-20 uppercase text-[#51C5FF]'
                        initial={{ opacity: 0, y: -50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.3, ease: [0.25, 0.1, 0.25, 1.0] }}
                        viewport={{ once: false }}
                    >
                        The Dream
                    </motion.div>
                    <motion.div
                        className='text-white text-base sm:text-lg md:text-xl font-medium p-4 sm:p-6 md:p-8 pl-0 sm:pl-4 md:pl-10 lg:pl-20 pr-4  lg:pr-16 leading-6 sm:leading-7'
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, delay: 0.4, ease: [0.25, 0.1, 0.25, 1.0] }}
                        viewport={{ once: false }}
                    >
                        To become the go-to competitive hub
                        for gamers worldwide — where talent is
                        discovered, communities are built, and
                        every player gets a fair chance to compete
                        and grow. The vision is to bridge the gap
                        between casual gaming & professional
                        esports by making competition accessible
                        to everyone.
                    </motion.div>
                </motion.div>
            </div>
        </div>
        
    )
}

export default QuivverDream